import { useState } from "react";
import "./Weekly.css";

const Weekly = ({ selectedDays, setSelectedDays }) => {
  

  const handleDayClick = (day) => {
    // اگر روز قبلا انتخاب شده بود، از حالت انتخاب خارج می‌شود
    if (selectedDays.includes(day)) {
      setSelectedDays(selectedDays.filter((d) => d !== day));
    } else {
      // در غیر این صورت به لیست روزهای انتخاب شده اضافه می‌شود
      setSelectedDays([...selectedDays, day]);
    }
  };

  const getDayClass = (day) => {
    // اگر روز جمعه است و انتخاب شده رنگ قرمز، در غیر این صورت سبز
    if (day === "friday" && selectedDays.includes(day)) {
      return "day selected-friday";
    }
    // برای روزهای دیگر اگر انتخاب شده باشند سبز
    return selectedDays.includes(day) ? "day selected" : "day";
  };

  return (
    <div className="d-flex justify-content-center">
      <div
        className={getDayClass("saturday")}
        onClick={() => handleDayClick("saturday")}
      >
        ش
      </div>
      <div
        className={getDayClass("sunday")}
        onClick={() => handleDayClick("sunday")}
      >
        ی
      </div>
      <div
        className={getDayClass("monday")}
        onClick={() => handleDayClick("monday")}
      >
        د
      </div>
      <div
        className={getDayClass("tuesday")}
        onClick={() => handleDayClick("tuesday")}
      >
        س
      </div>
      <div
        className={getDayClass("wednesday")}
        onClick={() => handleDayClick("wednesday")}
      >
        چ
      </div>
      <div
        className={getDayClass("thursday")}
        onClick={() => handleDayClick("thursday")}
      >
        پ
      </div>
      <div
        className={getDayClass("friday")}
        onClick={() => handleDayClick("friday")}
      >
        ج
      </div>
    </div>
  );
};

export default Weekly;
